<script setup lang="ts">
/// Modal hệ thống khi phát hiện stale-chunk sau deploy (xem useChunkReload).
/// Cố ý KHÔNG cho dismiss (không nút X / không đóng khi click overlay) — hành
/// động an toàn duy nhất là tải lại trang để nạp bản mới.
import { useI18n } from 'vue-i18n'

import AppButton from '@/shared/components/AppButton.vue'
import { useChunkReload } from '@/composables/useChunkReload'

const { t } = useI18n()
const { needsReload, reload } = useChunkReload()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="needsReload"
      class="fixed inset-0 z-[100] grid place-items-center bg-[#0f172a]/20 p-4"
      data-testid="chunk-reload"
      role="alertdialog"
      aria-modal="true"
    >
      <div
        class="
          flex
          w-full
          max-w-sm
          flex-col
          gap-4
          rounded-[24px]
          border border-[#edf2f7]
          bg-white
          p-6
          shadow-[0_24px_60px_-20px_rgba(15,23,42,0.22)]
        "
      >
        <h2 class="text-[20px] font-semibold leading-snug">
          {{ t('chunkReloadTitle') }}
        </h2>
        <p class="text-sm text-gray-600">
          {{ t('chunkReloadMessage') }}
        </p>
        <div class="flex justify-end">
          <AppButton
            variant="primary"
            data-testid="chunk-reload-action"
            @click="reload"
          >
            {{ t('chunkReloadAction') }}
          </AppButton>
        </div>
      </div>
    </div>
  </Teleport>
</template>
